export const chiefInjuries: { [key: string]: string }  = {
    'FDb9CWp2BRPFlk0xPTW7': 'Prezentarea echipei si masuri de securitate',
    '4slmVGDB0woE0p18D5uq': 'Apelul de urgenta',
    'hubRQ4vhJvfi13IbNvZA': 'Activitatea sefului de echipa',
    'mgJnorawcFB1OOoX05kD': 'Activitatea echipei',
    'FTZOp1iqJkSKMP7vLBjd': 'Raportul final'
};
